"use client";

import { c as _c } from "react/compiler-runtime";
import { CFormLabel, CFormSelect } from "@coreui/react";
import type { ComponentProps } from "react";
export const Select = {
  Root: "div",
  Label: CFormLabel,
  Trigger: CFormSelect
};
export type SelectRootProps = ComponentProps<"div">;
export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}
export interface SimpleSelectProps {
  options: SelectOption[];
  value: string | null;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  size?: "sm" | "md" | "lg";
  variant?: "outline" | "ghost";
  triggerStyle?: React.CSSProperties;
  "data-testid"?: string;
}
export function SimpleSelect(t0) {
  const $ = _c(20);
  const {
    options,
    value,
    onChange,
    placeholder,
    label,
    disabled,
    size,
    triggerStyle,
    "data-testid": dataTestId
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = label && <CFormLabel>{label}</CFormLabel>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = size === "lg" ? "lg" : size === "sm" ? "sm" : undefined;
  const t3 = value ?? "";
  let t4;
  if ($[2] !== onChange) {
    t4 = event => onChange(event.currentTarget.value);
    $[2] = onChange;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== placeholder) {
    t5 = placeholder && <option value="">{placeholder}</option>;
    $[4] = placeholder;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== options) {
    t6 = options.map(_temp);
    $[6] = options;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== dataTestId || $[9] !== disabled || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== triggerStyle) {
    t7 = <CFormSelect size={t2} value={t3} disabled={disabled} style={triggerStyle} data-testid={dataTestId} onChange={t4}>{t5}{t6}</CFormSelect>;
    $[8] = dataTestId;
    $[9] = disabled;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = triggerStyle;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t1 || $[18] !== t7) {
    t8 = <div>{t1}{t7}</div>;
    $[17] = t1;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function _temp(opt) {
  return <option key={opt.value} value={opt.value} disabled={opt.disabled}>{opt.label}</option>;
}